export default [
  {
    path: '/halal-decision-committee',
    name: 'halal-decision-committee',
    component: () => import('@/views/halal/decision-committee/DecisionCommittee.vue'),
    meta: {
      title: 'Halal Decision Committee',
      requiresAuth: true,
      action: 'browes',
      resource: 'Halal Decision Committee',
      pageTitle: 'Halal Decision Committee',
      breadcrumb: [
        {
          text: 'Halal Certificate',
        },
        {
          text: 'Decision Committee',
          active: true,
        },
      ],
    },
  },
]
